"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const toolkit_1 = require("@reduxjs/toolkit");
const screenConstants_1 = require("../../../constants/screenConstants");
const navContainer_1 = __importDefault(require("../../../components/navContainer/navContainer"));
const store_1 = require("../../../store");
const multiDocumentManager_1 = __importStar(require("../../../components/documentUpload/multiDocumentManager"));
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const businessOrganizationSlice_1 = require("./businessOrganizationSlice");
const utils_1 = require("../../../utils/utils");
const homeSlice_1 = require("../../home/homeSlice");
const choices_1 = require("../../../utils/choices");
const useAppNavigation_1 = __importDefault(require("../../../hooks/useAppNavigation"));
const input_1 = __importStar(require("../../../components/input/input"));
const analytics_1 = require("../../../utils/analytics/analytics");
const UploadCac = () => {
    const navigation = (0, useAppNavigation_1.default)();
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const { businessType, businessOrganization, messages } = (0, store_1.useAppSelector)((state) => {
        return {
            businessType: state.home.business_data
                ? state.home.business_data.business_organization.business_type
                : null,
            businessOrganization: state.home.business_data ? state.home.business_data.business_organization : null,
            messages: state.home.appMessages,
        };
    });
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [rcNumber, setRcNumber] = (0, react_1.useState)('');
    const [newCacDocuments, setNewCacDocuments] = (0, react_1.useState)(businessOrganization ? businessOrganization.cac_documents : []);
    // SUBMIT FORM DATA
    const submitForm = async () => {
        setIsLoading(true);
        const payload = {
            rc_bn_number: rcNumber.toString(),
        };
        const result = await dispatch((0, businessOrganizationSlice_1.addRCNumber)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'submit_rc_document',
            status: 'submitted',
            location: 'screen_UploadCac',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'submit_rc_document',
                status: 'success',
                location: 'screen_UploadCac',
            });
            setIsLoading(false);
            if (messages ? messages.messages.length > 0 : false) {
                dispatch((0, homeSlice_1.showMessage)());
            }
            else {
                navigation.navigate(screenConstants_1.HOME_SCREEN);
            }
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'submit_rc_document',
                status: 'fail',
                location: 'screen_UploadCac',
            });
            setErrors(result.payload);
            setIsLoading(false);
        }
    };
    return (react_1.default.createElement(navContainer_1.default, { errors: errors, isLoading: isLoading, footer: react_1.default.createElement(primaryButton_1.default, { title: "Submit", onPress: submitForm, disabled: false, eventName: "businessOrganization_save" }), childrenTitle: "Upload Documents" },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_NUMBER, label: "Registered Company Number", placeholder: "Registered Company Number", setValue: setRcNumber, error: (0, utils_1.getError)('rc_bn_number', errors), value: rcNumber || '' })),
            react_1.default.createElement(multiDocumentManager_1.default, { documents: newCacDocuments, setDocuments: setNewCacDocuments, screenName: screenConstants_1.UPLOAD_CAC_SCREEN, requirements: businessType ? (0, choices_1.getCacRequirements)(businessType.toString()) : [], mimeType: ['application/pdf', 'image/png', 'image/jpeg'], uploadTo: multiDocumentManager_1.submitCacFile, deleteDocument: businessOrganizationSlice_1.deleteCacCertificate, error: (0, utils_1.getError)('business_cac_certificates', errors), label: "Upload CAC Document" }))));
};
exports.default = UploadCac;
